import React from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar.js";
import dog1 from "../images/aboutpet1.avif";
import dog2 from "../images/aboutpet2.avif";
import dog3 from "../images/dogcontact2.avif";
import abhay from "../images/abhay.avif";
import brian from "../images/brian.avif";
import stephen from "../images/stephen.png";
import nathan from "../images/nathan.avif";
import Footer from "./Footer.js";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const buttonVariants = {
  hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
};

const About = () => {
  return (
    <div>
      <Helmet>
  <title>About Us – Furbabies.AI</title>
  <meta name="description" content="We built Furbabies.AI to help pet lovers everywhere give their furbabies the healthiest, happiest life possible using the power of AI." />
</Helmet>
      <Navbar />
      <div className="bg-[#bda697] mt-44 flex flex-col md:flex-row items-center">
        <motion.div
          className="md:w-1/2 text-left ml-4 mt-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <motion.h1
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className="lg:text-[90px] lg:leading-[100px] text-6xl xl:pl-12  font-bold  text-white"
          >
            Welcome to <br />
            Furbabies.AI!
          </motion.h1>
        </motion.div>

        <motion.div
          className="md:w-1/2 flex justify-center mt-8 md:mt-0 "
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          <div className="hidden xl:block relative left-10 top-4 transform -translate-x-1/2">
            <div className="text-6xl text-[#d1c0b5] animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>

          <img
            src={dog1}
            alt="Dog"
            className="rounded-xl max-w-sm md:max-w-md"
               loading="lazy"
          />

          <div className="hidden xl:block relative top-10 transform translate-x-1/2">
            <div className="text-4xl text-[#d1c0b5] animate-paw-right-left">
              <i className="fa fa-paw"></i>
            </div>
          </div>
          <div className="hidden xl:block relative top-36 right-12 transform translate-x-2 -rotate-12">
            <div className="text-9xl text-[#d1c0b5]">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="bg-[#ffffff] flex flex-col md:flex-row pt-10 items-center">
        <motion.div
          className="w-full md:w-1/2 flex justify-center mt-8 md:mt-0 px-4 order-2 md:order-1"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          <div className="hidden xl:block relative top-20 sm:top-32 transform translate-x-1">
            <div className="text-6xl sm:text-9xl text-[#bda697] animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>
          <img
            src={dog2}
            alt="Cat"
            className="rounded-xl max-w-[100%] sm:max-w-lg md:max-w-xl"
               loading="lazy"
          />
          <div className="hidden xl:block relative transform translate-x-1/2">
            <div className="text-4xl sm:text-6xl text-[#bda697] animate-paw-right-left">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="w-full md:w-1/2 text-left px-4 sm:px-8 order-1 md:order-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <motion.h1
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className=" text-5xl  lg:text-[60px] lg:leading-[70px] xl:p-6  font-bold text-black"
          >
            Extending the Loving Companionship of
            <br />
            Our Beloved Furbabies
          </motion.h1>
          <motion.p
            variants={textVariants}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            transition={{ delay: 0.2, duration: 1 }}
            className="mt-4 xl:p-7  poppins-text text-xl lg:text-[18px] text-justify lg:leading-[28px] text-[#222222]"
          >
            Furbabies.AI is more than just a service - we’re a service with a
            mission led by passionate Pet Lovers. As Pet Lovers, we see our
            Furbabies as Family. Yes, we are those people who buy our Furbabies
            the best food - even making it from scratch. We are those people who
            buy our Furbabies toys. We are those people who buy our Furbabies
            cute clothes. Yes, we are “those people. As Pet Lovers, we have
            founded Furbabies.AI as a social impact venture using the power of
            Artificial Intelligence (AI) and technology to create an affordable,
            easy-to-use pet care service for our fellow Pet Lovers to assess
            their pet’s health, safety, and nutrition from the comforts of home,
            or from anywhere in the world. We have built Furbabies.AI to help
            address the worldwide epidemic of loneliness - affecting 1 out of 4
            people in the world - because we know pets are some of the best
            companions. Loneliness is a leading cause of physical and mental
            health problems. People with pets are healthier and happier. If you
            are one of “those people” who truly love their pets, we welcome you
            as you join other Pet Lovers who subscribe to Furbabies.AI.
            Together, let’s make the world less lonely with safe and healthy
            furbabies everywhere. That’s why we do what we do. That’s why
            Furbabies.AI is available in the Top 10 most frequent languages
            spoken across the world. That’s why we donate 1% of our profits to
            Humane Society International. Yes, we are proudly “those people.
          </motion.p>
        </motion.div>
      </div>

      <section className="py-12 sm:py-24 px-4 sm:px-8 bg-[#e8e1da]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h2
            className=" text-5xl  lg:text-[60px] lg:leading-[70px]  font-bold text-gray-900 mb-8 sm:mb-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Our Values
          </motion.h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12">
            <motion.div
              className="p-5 bg-[#e8e1da] rounded-lg flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="text-4xl text-[#a07855] mb-4">
                <i className="fa fa-heart"></i>
              </div>
              <h3 className="text-[32px] font-semibold text-gray-900 mb-4">
                Companionship for Good
              </h3>
              <p className="text-gray-600 poppins-text opacity-60 text-lg lg:text-[18px]  lg:leading-[28px] ">
                We approach every pet with empathy and kindness, ensuring their
                comfort and well-being. Our caring touch extends to all animals,
                from the tiniest hamster to the largest dog, creating a safe and
                loving environment where their happiness and health flourish.
              </p>
            </motion.div>

            <motion.div
              className="p-6 bg-[#e8e1da] rounded-lg flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="text-4xl text-[#a07855] mb-4">
                <i className="fa fa-star"></i>
              </div>
              <h3 className="text-[32px] font-semibold text-gray-900 mb-4">
                Compassion for All
              </h3>
              <p className="text-gray-600 poppins-text opacity-60 text-lg lg:text-[18px] lg:leading-[28px] ">
                We uphold uncompromising standards in every aspect of our
                service, from meticulous medical care to unparalleled customer
                service. Our dedication to excellence is a promise that your pet
                will receive the best, ensuring their well-being and your peace
                of mind.
              </p>
            </motion.div>

            <motion.div
              className="p-6 bg-[#e8e1da] rounded-lg flex flex-col"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="text-4xl text-[#a07855] mb-4">
                <i className="fa fa-lock"></i>
              </div>
              <h3 className="text-[32px] font-semibold text-gray-900 mb-4">
                Credibility
              </h3>
              <p className="text-gray-600 poppins-text opacity-60 text-lg lg:text-[18px] lg:leading-[28px] ">
                Your trust is paramount in our relationship. We are committed to
                maintaining it through unwavering transparency, reliability, and
                clear communication. Count on us to be your dependable partner
                in pet care, always putting your pet's best interests first.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-12 sm:py-24 px-4 sm:px-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.h2
            className="text-5xl lg:text-[60px] text-center lg:leading-[70px] font-bold text-gray-900 mb-8 sm:mb-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Meet Our Team
          </motion.h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
            {[
              {
                name: "Abhay Bhaskar Mallampalli",
                title: "Co-Founder/Chief of Furbaby Technology",
                description:
                  "A recent Master’s degree graduate in Data Science at the University of Texas at Arlington, Abhay Bhaskar Mallampalli, a student from India, was inspired to create Furbabies.AI by what he saw on the streets of India, as well as his experience as a pet owner in the United States. Abhay explains, “Before coming to America where I have recently graduated with my Master’s degree, I saw so many pets in India whose owners could not get the veterinary care they needed. Here in the United States, I have personally seen how hard it is for so many pet owners to afford the veterinary care their pets deserve.” Abhay built the software of Furbabies.AI.",
                image: abhay,
              },
              {
                name: "Nathan Frischknecht",
                title: "Co-Founder/Chief of Furbaby Graphics and Art",
                description:
                  "An undergraduate student in UI/UX at Brigham Young University (BYU) in Provo, Utah, Nathan Frischknecht is a User Interface/User Experience Designer with interests in visual and narrative expression. He also looks for ways to help others through design. Nathan was inspired to help co-found Furbabies.AI because of the potential for good this software has. “Learning that pets have the power to alleviate loneliness and improve mental health excited me, and I thought: If there’s a way to make this companionship available to more people, I want to be a part of that effort.” Nathan has built the user interface of Furbabies.AI.",
                image: nathan,
              },
              {
                name: "Brian Meshkin",
                title: "Co-Founder/Chief of Furbaby Operations",
                description:
                  "As an award-winning social entrepreneur and health technology executive, Brian grew up with cats and dogs, and today is the proud “dog dad” of Duke and Duchess - a mini golden doodle and a cavapoo, as Brian and his wife Kerry are now empty nesters. Having seen both his Mom and his Mother-in-Law spend a small fortune on veterinary care, he felt inspired to try and come up with a solution to help Pet Lovers find an economical way to triage care at home. As a social impact entrepreneur and investor, he was struck by the epidemic of loneliness that is spreading across the world and he truly believes that dogs can be a “man’s best friend.” And so Brian has been happy to co-found Furbabies.AI, fund its development, and mentor two young entrepreneurs as his co-founders.",
                image: brian,
              },{
                name: "Dr. Stephen Lewis",
                // title: "Co-Founder/Chief of Furbaby Operations",
                description:
                  "Dr. Stephen Lewis is a Professor, Department of Pediatrics and Department of Pharmacology, Case Western Reserve University School of Medicine in Cleveland, Ohio.  In addition to being a DVM, he has his Ph.D. He leads a laboratory focused on the cellular mechanisms by which endogenous thiols (e.g., cysteine, cysteamine and glutathione) and S-nitrosothiols(e.g., S-nitrosocysteine, S-nitrosocysteamine and S-nitrosoglutathione), as well as their synthesis/degradation pathways influence the central and peripheral regulation of microcirculatory and ventilatory systems in rats and mice under both physiological and pathophysiological settings. His lab employs a multi-disciplinary research approach ranging from whole animal physiology and pharmacology to electrophysiology to cell/molecular biology. Steve is an advisor to various Profound Ventures companies and has a passion for animals as a Pet Lover himself.",
                image: stephen,
              },
            ].map((member, index) => (
              <motion.div
                key={index}
                className="flex flex-col border border-1 rounded-lg p-6 h-full"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <div className="lg:flex flex-row  items-center">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-44 h-44 rounded-full object-cover   border-gray-300 mr-7"
                    loading="lazy"
                  />
                  <div>
                    <h3 className="text-[32px] leading-[36px] font-semibold text-gray-900">
                      {member.name}
                    </h3>
                    <p className="text-gray-600 poppins-text text-[18px] leading-[26px] mt-3">
                      {member.title}
                    </p>
                  </div>
                </div>
                <p className=" poppins-text opacity-60 text-lg lg:text-[18px] text-justify lg:leading-[28px] mt-7">
                  {member.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <div className="bg-white mt-20 text-center flex flex-col-reverse md:flex-row items-center max-w-6xl mx-auto">
        <motion.div
          className="md:w-1/2 flex justify-center md:mb-0 -ml-16"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <div className="hidden xl:block relative top-16 left-14 transform -translate-x-1/2">
            <div className="text-6xl text-[#bda697] animate-paw-left-right">
              <i className="fa fa-paw"></i>
            </div>
          </div>

          <img
            src={dog3}
            alt="Dog"
            className="rounded-xl max-w-sm md:max-w-md"
            loading="lazy"
          />
          <div className="hidden xl:block relative transform translate-x-1/2">
            <div className="text-6xl text-[#bda697] animate-paw-right-left">
              <i className="fa fa-paw"></i>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="md:w-1/2 ml-4 sm:ml-8 md:ml-20  text-left px-6"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <motion.h2
            className="text-5xl  lg:text-[60px] lg:leading-[70px] font-semibold text-gray-800 "
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Ready to Join with Other Pet Lovers?
          </motion.h2>
          <motion.p
            variants={textVariants}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            transition={{ delay: 0.2, duration: 1 }}
            className="mt-4 text-xl lg:text-[18px] lg:leading-[28px] poppins-text text-gray-600"
          >
            Start a free 30-day trial today and give your furbaby the care they
            deserve.
          </motion.p>

          <motion.button
            variants={buttonVariants}
            whileHover="hover"
            className="mt-6 text-xl px-12 py-4 bg-[#967d6c] lg:text-[20px] lg:leading-[26px]  text-white font-bold rounded-full"
          >
            <Link to="/signup" className="text-white">
              Join Today
            </Link>
          </motion.button>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
